import { render, staticRenderFns } from "./ObjectiveOdontogram.vue?vue&type=template&id=eae0a254&scoped=true&"
import script from "./ObjectiveOdontogram.vue?vue&type=script&lang=js&"
export * from "./ObjectiveOdontogram.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveOdontogram.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ObjectiveOdontogram.vue?vue&type=style&index=1&id=eae0a254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae0a254",
  null
  
)

export default component.exports